import React from 'react'
import { COLORS } from '@btime/constants'

import AbsolutePageTemplate from '../../../../components/templates/AbsolutePageTemplate'
import PageHeader from '../_shared/PageHeader'
import ServiceOrderLoader, { useServiceOrder } from '../_load/ServiceOrderLoader'
import PdfOptionsFormHandler from '../../../../components/pdf/options/_form/PdfOptionsFormHandler'
import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import Preview from '../../../../components/pdf/Preview'
import Separator from '../../../../components/pdf/Separator'
import Image from '../../../../components/pdf/Image'
import Page from '../../../../components/pdf/Page'
import { PropostaEnterprise } from '../propostaEnterprise/TemplateInternoPropostaEnterprisePdfPage'
import { PropostaSmb } from '../propostaSmb/TemplateInternoPropostaSmbPdfPage'
import ParentServiceOrderLoader, { useParentServiceOrder } from '../_load/ParentServiceOrderLoader'
import View from '../../../../components/pdf/View'
import Text, { Bold } from '../../../../components/pdf/Text'
import { findReplyByQuestionId } from '../_helpers/pdfHelpers'
import { Justify } from '../_shared/Justify'

const Content = () => {
  const { replies } = useServiceOrder()
  const focalPointName = findReplyByQuestionId(replies, 1791)?.value
  const pointFocalPhone = findReplyByQuestionId(replies, 1792)?.value
  const pointFocalEmail = findReplyByQuestionId(replies, 1793)?.value

  const focalPointCompanyName = findReplyByQuestionId(replies, 1794)?.value
  const pointFocalCompanyPhone = findReplyByQuestionId(replies, 1795)?.value
  const pointFocalCompanyEmail = findReplyByQuestionId(replies, 1796)?.value

  const nameCompany = findReplyByQuestionId(replies, 1741)?.value
  const CNPJCompany = findReplyByQuestionId(replies, 1742)?.value
  const companyLocation = findReplyByQuestionId(replies, 1744)?.value?.search

  return (
    <>
      <ContentProposta />
      <Text size="medium" align="justify">
        <View pageBreakAfter>
          <Header />
          <Text size="medium" bold>
            Equipe do Projeto
          </Text>
          <br />
          <Text size="medium" bold>
            Ponto Focal da Btime:
          </Text>
          <ul>
            <li>Nome: {focalPointName}</li>
            <li>Telefone/WhatsApp: {pointFocalPhone}</li>
            <li>Email: {pointFocalEmail}</li>
          </ul>
          <Text size="medium" bold>
            Ponto Focal da Sua Empresa:
          </Text>
          <ul>
            <li>Nome: {focalPointCompanyName}</li>
            <li>Telefone/WhatsApp: {pointFocalCompanyPhone}</li>
            <li>Email: {pointFocalCompanyEmail}</li>
          </ul>
          <Text size="medium" bold>
            CONTRATO PRESTAÇÃO DE SERVIÇOS E LICENÇA DE USO DE SOFTWARE
          </Text>
          <br />
          Pelo presente instrumento particular, as partes acima qualificadas têm entre si, justo e acordado, o presente
          Contrato de Prestação de Serviços e Licença de Uso de Software, o qual será regido pelas cláusulas e condições
          a seguir, que mutuamente aceitam e outorgam, a saber:
          <br />
          <br />
          <Bold>CONTRATADA: BTIME SOLUÇÕES LTDA.</Bold>, inscrita no CNPJ/MF sob o nº.21.849.504/0001-50, com sede na
          Alameda Vicente Pizon, n°. 54, Vila Olímpia, São Paulo/SP, CEP 04547-130, neste ato representada de acordo com
          seus atos constitutivos, de agora em diante denominada simplesmente <Bold>“BTIME”</Bold>; e, do outro lado;
          <br />
          <br />
          <Bold>CONTRATANTE:</Bold> {nameCompany}, inscrita no CNPJ/MF sob o n°. {CNPJCompany},Inscrição Municipal nº
          {CNPJCompany} com sede na
          {companyLocation}, neste ato representada de acordo com seus atos constitutivos, de agora em diante denominada
          simplesmente <Bold>“CONTRATANTE”</Bold>.
          <br />
          <br />
          <Text size="medium" bold>
            DO OBJETO
          </Text>
          <ul>
            <li>
              Pelo presente instrumento, a <Bold>BTIME</Bold> se obriga a prestar o serviço de disponibilização do
              SOFTWARE, e sua respectiva licença de uso, não exclusiva e intransferível, em favor da
              <Bold>CONTRATANTE</Bold>, de acordo com os prazos e as condições definidas neste contrato e em seus
              <Bold>ANEXOS</Bold>, consubstanciados na(s) <Bold>PROPOSTA(S) BTIME</Bold> que venha(m) a ser firmada(s)
              entre as Partes e que passarão a ser parte integrante(s) e indissociável(is) do presente instrumento.
            </li>
            <li>
              Adicionalmente à disponibilização do <Bold>SOFTWARE</Bold>, a <Bold>BTIME</Bold> se compromete a prestar
              serviços de implantação do SOFTWARE, bem como os serviços de suporte e atualização deste.
            </li>
          </ul>
          <Text size="medium" bold>
            DOS MÓDULOS DISPONIBILIZADOS
          </Text>
          <br />
          <Bold>2.1. </Bold>O <Bold>SOFTWARE</Bold> disponibilizado pela BTIME tem natureza de modelo “SaaS” (Software
          as a Service), cuja informações são hospedadas atualmente na nuvem Microsoft Azure e acessadas remotamente
          pela <Bold>CONTRATANTE</Bold>, sendo composto por diversos módulos, sendo disponibilizados à{' '}
          <Bold>CONTRATANTE</Bold> unicamente os módulos contratados, os quais estão expressamente listados e
          precificados no(s)
          <Bold>ANEXO(S).</Bold>
          <br />
          <br />
          <Bold>2.1.1.</Bold> A nuvem em que as informações estão hospedadas poderá ser alterada, evento que poderá ser
          previamente comunicado à <Bold>CONTRATANTE.</Bold> Nesse caso, serão mantidos todos os níveis de serviços com
          o mesmo nível de segurança e confiabilidade e não ocorrerá qualquer interrupção dos serviços oferecidos.****
          <br />
          <br />
          <Text>DOS SERVIÇOS DE IMPLANTAÇÃO, SUPORTE, E ATUALIZAÇÃO DO SOFTWARE</Text>
          <Bold>3.1.</Bold> Os serviços relacionados ao <Bold>SOFTWARE</Bold> compreendem os serviços de: Acessos,
          Onboarding, Professional Services e Consultoria, Manutenção, Treinamento, Informação e Suporte; entre outros
          serviços eventualmente previstos na <Bold>PROPOSTA BTIME</Bold>.
          <br />
          <br />
          <Bold>3.1.1. </Bold> A alimentação de bases de dados do <Bold>SOFTWARE</Bold> será de responsabilidade da{' '}
          <Bold>CONTRATANTE</Bold>, e pode ser realizada pela BTIME desde que haja prévia autorização e aprovação do
          conteúdo pela <Bold>CONTRATANTE</Bold>.
          <br />
          <br />
          <Bold>3.1.2.</Bold> Os treinamentos deverão ser de acordo com os limites previstos na PROPOSTA{' '}
          <Bold>BTIME</Bold> quanto à quantidade e pessoas por turma.
          <br />
          <br />
          <Bold>3.1.3.</Bold> As despesas de hospedagem e locomoção para fora do município de São Paulo são de
          responsabilidade da CONTRATANTE.
          <br />
          <br />
          <Bold>3.2. </Bold> Durante a vigência deste contrato, a <Bold>BTIME</Bold> disponibilizará suporte pelo e-mail
          suporte@btime.com.br, e chat na solução, para os administradores da Plataforma eleitos pela{' '}
          <Bold>CONTRATANTE</Bold>, de segunda a sexta-feira, das 09h:00am às 18h:00pm, exceto sábados, domingos e
          feriados.
          <br />
          <br />
          <Bold>3.3.</Bold> A <Bold>BTIME</Bold> manterá o <Bold>SOFTWARE</Bold> atualizado em seus servidores,
          disponibilizando à <Bold>CONTRATANTE</Bold>
          sempre a última versão homologada durante a vigência deste contrato.
          <br />
          <br />
          <Text size="medium" bold>
            DO PREÇO E FORMA DE PAGAMENTO
          </Text>
          <br />
          <Bold>4.1.</Bold> Pela prestação dos serviços objeto deste contrato, a <Bold>CONTRATANTE</Bold> se obriga a
          pagar:
          <ol>
            <li>
              O valor da <Bold>TAXA DE IMPLANTAÇÃO</Bold> e dos <Bold>MÓDULOS</Bold> previsto no(s){' '}
              <Bold>ANEXO(S)</Bold> deste contrato, de acordo com as quantias e condições de pagamento nele(s)
              descritas;
            </li>
            <li>
              No último dia de cada mês será feita a apuração das licenças em uso, bem como os módulos, sendo gerada a
              fatura para pagamento até a data acordada no(s) <Bold>ANEXO(S)</Bold>.
            </li>
          </ol>
          <Bold>4.2.</Bold> Para pagamentos provenientes do exterior, é de responsabilidade da <Bold>CONTRATANTE</Bold>{' '}
          quaisquer taxas de exportação de serviços e/ou variações cambiais que venham a incidir, devendo a{' '}
          <Bold>BTIME</Bold>
          receber o valor líquido total através de transferência bancária internacional.
          <br />
          <br />
          <Bold>4.3. </Bold> No caso de atraso de qualquer pagamento previsto neste contrato ou nos{' '}
          <Bold>ANEXO(S)</Bold>, a CONTRATANTE ficará sujeita ao pagamento do valor devido acrescido de juros de mora de
          1% (um por cento) ao mês, multa moratória de 02% (dois por cento) e correção monetária pelo índice IPCA.{' '}
          <br />
          <br />
          <Bold>4.4. </Bold> No caso de inadimplência por período superior a 30 (trinta) dias, é lícito à{' '}
          <Bold>BTIME</Bold> suspender a prestação dos serviços, independentemente de qualquer aviso, notificação, ou
          formalidade adicional, sem prejuízo da cobrança do débito, observado, ainda, no caso de inadimplência superior
          a 60 (sessenta) dias, o direito de a <Bold>BTIME</Bold> proceder com a rescisão contratual.
          <br />
          <br />
          <Bold>4.5.</Bold> Os valores previstos neste contrato e seus <Bold>ANEXO(S)</Bold> serão reajustados a cada 12
          (doze) meses, aplicando correção monetária com base no IPCA, ou outro índice que venha a substituí-lo, no caso
          de sua extinção.
          <br />
          <br />
          <Text size="medium" bold>
            DAS OBRIGAÇÕES DAS PARTES
          </Text>
          <br />
          <Bold>5.1.</Bold> Sem prejuízo das demais obrigações previstas neste contrato, a <Bold>CONTRATANTE</Bold> se
          obriga a:
          <ol>
            <li>
              Fornecer à <Bold>BTIME</Bold>, a qualquer tempo, todas as informações necessárias para a execução do
              objeto deste contrato, com o máximo de presteza;
            </li>
            <li>
              Zelar pelo SOFTWARE objeto deste contrato, impedindo que terceiros venham a ter acesso à tecnologia e ao
              know-how empreendidos para seu desenvolvimento e implantação;
            </li>
            <li>
              Respeitar e envidar seus melhores esforços para que seus diretores, empregados, prepostos, e quaisquer
              terceiros a seu serviço, respeitem os direitos da <Bold>BTIME</Bold> sobre o <Bold>SOFTWARE</Bold>;
            </li>
            <li>
              Notificar a <Bold>BTIME</Bold>, imediatamente, caso venha a ter conhecimento de qualquer violação dos seus
              direitos sobre o <Bold>SOFTWARE</Bold>, auxiliando a <Bold>BTIME</Bold> na defesa de seus direitos;
            </li>
            <li>
              Responder pelos danos eventualmente causados à <Bold>BTIME</Bold> ou a terceiros, por atos de
              responsabilidade da <Bold>CONTRATANTE</Bold> ou de seus prepostos.
            </li>
          </ol>
          <Bold>5.2.</Bold> Sem prejuízo das demais obrigações previstas neste contrato, a <Bold>BTIME</Bold> se obriga
          a:
          <ol>
            <li>
              Executar os serviços objeto deste instrumento de modo a atingir suas finalidades, nos termos deste
              contrato e do(s) <Bold>ANEXO(S)</Bold>;
            </li>
            <li>
              Diligenciar para atender satisfatoriamente às necessidades da <Bold>CONTRATANTE</Bold> provendo todo
              amparo no objeto deste contrato;
            </li>
            <li>
              Empregar, continuamente, as melhores técnicas, tecnologias e materiais, visando a melhoria e otimização de
              seus processos, de forma a traduzir sua prática em benefícios reais para a <Bold>CONTRATANTE</Bold>;
            </li>
            <li>
              Assumir todos os encargos trabalhistas, securitários, previdenciários, e quaisquer outros relativos à mão
              de obra que empregar na execução do objeto deste contrato.
            </li>
          </ol>
          <br />
          <Text size="medium" bold>
            DAS LIMITAÇÕES DE RESPONSABILIDADE
          </Text>
          <br />
          <Bold>6.1.</Bold> A <Bold>BTIME</Bold> usará seus melhores esforços para que os servidores que hospedam o{' '}
          <Bold>SOFTWARE</Bold> funcionem com alta confiabilidade. Porém, a <Bold>CONTRATANTE</Bold> declara ciência de
          que o funcionamento desses servidores poderá ser afetado por inúmeros fatores, todos fora do controle e
          diligência da <Bold>BTIME</Bold>, tais como falhas nas operadoras interconectadas à rede, eventos de força
          maior, caso fortuito, e outros, motivo pelo qual a <Bold>BTIME</Bold> não garante funcionamento ininterrupto
          desses equipamentos.
          <br />
          <br />
          <Bold>6.2.</Bold> A <Bold>BTIME</Bold> não se responsabiliza por perdas e danos causados, de qualquer tipo ou
          natureza, pela utilização irregular dos serviços por ela prestados, ou em função de problemas de software,
          sistemas e aplicativos de terceiros, ou hardware, de responsabilidade exclusiva de seus fabricantes, bem como
          por perdas de dados, vírus, e quaisquer outros eventos que fujam ao controle e diligência da{' '}
          <Bold>BTIME</Bold>.
          <br />
          <br />
          <Bold>6.3.</Bold> A <Bold>BTIME</Bold> não garante, sob nenhuma hipótese, que os sistemas de conexão com os
          serviços (via telefônica, via cabo, ou qualquer outro) estejam livres de possíveis falhas ou interrupções, não
          se responsabilizando pela qualidade da rede utilizada para acesso ao serviço, vez que esta é mantida por
          terceiros, que não a <Bold>BTIME</Bold>, e, portanto, foge do seu controle, diligência e responsabilidade.
          <br />
          <br />
          <Bold>6.4.</Bold> Todas as credenciais de acesso (usuários e/ou senhas) fornecidas à <Bold>CONTRATANTE</Bold>,
          e/ou criadas pela <Bold>CONTRATANTE</Bold>, para utilização do serviço e do <Bold>SOFTWARE</Bold>, são
          pessoais e intransferíveis, ficando a <Bold>CONTRATANTE</Bold> responsável exclusiva por toda e qualquer
          utilização indevida de tais credenciais de acesso, inclusive por terceiros, sem qualquer responsabilidade da{' '}
          <Bold>BTIME</Bold>. Todas as permissões atribuídas a cada usuário são de responsabilidade integral da{' '}
          <Bold>CONTRATANTE</Bold>, ficando a <Bold>BTIME</Bold> isenta de qualquer responsabilidade pela eventual
          atribuição de poderes indevidos a qualquer usuário.
          <br />
          <br />
          <Bold>6.5.</Bold> É de responsabilidade exclusiva da <Bold>CONTRATANTE</Bold> o conteúdo disponibilizado aos
          seus funcionários, por meio do uso do <Bold>SOFTWARE</Bold>, ficando a <Bold>BTIME</Bold> e seus prepostos,
          eximidos de qualquer responsabilidade por informações incorretas ou de qualquer forma inapropriadas, que
          venham a ser exibidas pelo <Bold>SOFTWARE</Bold>, na interação com os clientes da <Bold>CONTRATANTE</Bold>.
          <br />
          <br />
          <Bold>6.6.</Bold> A <Bold>BTIME</Bold> não tem obrigação de monitoramento do conteúdo disponibilizado por
          terceiros por meio do uso do <Bold>SOFTWARE</Bold> e não se responsabiliza por eventuais danos deles
          decorrentes. A <Bold>BTIME</Bold> se reserva ao direito de tomar ciência de notícia e excluir conteúdo em
          violação aos seus Termos de Uso e Política de Privacidade, disponível em www.btime.io/termosdeuso .<br />
          <Bold>6.7.</Bold> A <Bold>BTIME</Bold> não garante que o <Bold>SOFTWARE</Bold> operará em combinações outras,
          que não aquelas para as quais foi especificado, nos termos do documento padrão de requisitos mínimos entregue
          à <Bold>CONTRATANTE</Bold>.
          <br />
          <br />
          <Bold>6.8.</Bold> Não caberá responsabilidade a qualquer das partes pelo não cumprimento de suas obrigações
          contratuais caso o inadimplemento decorra de caso fortuito ou eventos de força maior, que impeçam, temporária
          ou definitivamente, o cumprimento de quaisquer obrigações assumidas neste contrato, conforme disposto no
          artigo 393 do Código Civil.
          <br />
          <br />
          <Bold>6.8.1.</Bold> A parte que se sentir impossibilitada de dar cumprimento às suas obrigações contratuais
          por fatos oriundos de caso fortuito ou eventos de força maior deverá comunicar a outra parte, no prazo máximo
          de 48 (quarenta e oito) horas após a ocorrência, sob pena de não lhe ser possível invocar esta cláusula.
          <br />
          <br />
          <Text size="medium" bold>
            DAS CONDIÇÕES RELATIVAS À LICENÇA DE USO DO SOFTWARE E DA PROPRIEDADE INDUSTRIAL E INTELECTUAL
          </Text>
          <br />
          <Bold>7.1.</Bold> O presente contrato não importa em transmissão de quaisquer direitos de propriedade
          industrial e/ou intelectual entre as partes, sendo seu objeto a mera disponibilização de programa de
          computador/mobile como serviço, acompanhado de licença de uso, tudo nos termos, limites, e condições previstas
          neste contrato e seu anexo.
          <br />
          <br />
          <Bold>7.2.</Bold> Nos termos da cláusula 7.1, pertencem exclusivamente à <Bold>BTIME</Bold> os direitos de
          propriedade industrial e intelectual sobre o <Bold>SOFTWARE</Bold>, seu código fonte, sua documentação, e
          todos os seus componentes, tais como textos, imagens, marcas, relatórios, gráficos, e quaisquer outros, a
          estes não se limitando, cujo uso será disponibilizado como serviço à CONTRATANTE, observados os termos e
          condições deste instrumento.
          <br />
          <br />
          <Bold>7.3.</Bold> É vedado à <Bold>CONTRATANTE</Bold> ceder, transferir, alugar, vender, comercializar a
          licença de uso do <Bold>SOFTWARE</Bold>, que não poderá beneficiar terceiros que não a{' '}
          <Bold>CONTRATANTE</Bold>, salvo com prévia e expressa autorização firmadas pelos representantes legais da{' '}
          <Bold>BTIME</Bold>.
          <br />
          <br />
          <Bold>7.4.</Bold> Considerando que o <Bold>SOFTWARE</Bold> é disponibilizado como serviço à{' '}
          <Bold>CONTRATANTE</Bold>, o backup das informações será realizado pela <Bold>BTIME</Bold>, de modo que é
          vedado à <Bold>CONTRATANTE</Bold> manter, em seu poder, qualquer cópia do <Bold>SOFTWARE</Bold>, que, se
          ocorrer, será considerada como cópia não autorizada, e sua mera existência será compreendida como violação de
          direitos autorais.
          <br />
          <br />
          <Bold>7.5.</Bold> A <Bold>CONTRATANTE</Bold> não poderá, direta ou indiretamente, inclusive através de atos de
          seus prepostos ou terceiros a seu serviço, copiar, doar, modificar, transferir, sublicenciar, ceder, vender,
          dar em locação, dar em garantia, doar, ou alienar a terceiros o <Bold>SOFTWARE</Bold>, sob qualquer forma ou
          modalidade, gratuita ou onerosa, provisória ou permanente, no todo ou em parte, nem acessá-lo mediante a
          quebra de senhas, ou submetê-lo a processos de engenharia reversa ou, ainda, traduzi-lo ou decodificá-lo, no
          todo ou em parte, ficando ciente que a infração, total ou parcial, constituirá violação de direitos autorais.
          As mesmas vedações aplicam-se a quaisquer documentações ou informações relativas ao <Bold>SOFTWARE</Bold>.
          <br />
          <br />
          <Bold>7.6.</Bold> É vedado à <Bold>CONTRATANTE</Bold> o acesso aos códigos fonte do <Bold>SOFTWARE</Bold>,
          para qualquer finalidade.
          <br />
          <br />
          <Bold>7.7.</Bold> A titularidade de qualquer criação intelectual e/ou industrial decorrente dos serviços
          previstos neste contrato, ainda que sob encomenda da <Bold>CONTRATANTE</Bold>, pertencerá exclusivamente à{' '}
          <Bold>BTIME</Bold>, que poderá livremente utilizar, comercializar, e explorar tal criação, sem qualquer
          direito de objeção da <Bold>CONTRATANTE</Bold>.
          <br />
          <br />
          <Bold>7.8.</Bold> A <Bold>CONTRATANTE</Bold> reconhece e declara que toda a tecnologia e know how empregado no
          desenvolvimento e implantação do <Bold>SOFTWARE</Bold>, decorrente de significantes investimentos da{' '}
          <Bold>BTIME</Bold>, é de titularidade exclusiva da <Bold>BTIME</Bold>, e não se transmite à{' '}
          <Bold>CONTRATANTE</Bold>, em razão do presente contrato.
          <br />
          <br />
          <Text size="medium" bold>
            DA CONFIDENCIALIDADE
          </Text>
          <br />
          <Bold>8.1.</Bold> As partes se obrigam a manter o mais absoluto sigilo com relação a quaisquer dados,
          informações, materiais, pormenores, inovações, segredos comerciais, marcas, estratégias, relatórios, criações,
          designs, layouts, especificações técnicas e comerciais, dados pessoais, dentre outros, doravante denominados{' '}
          <Bold>“DADOS CONFIDENCIAIS”</Bold>, a que, diretamente ou através de seus funcionários e/ou prepostos, venham
          a ter acesso, conhecimento ou que venha a lhe ser confiado durante e em razão do presente instrumento.
          Comprometem-se, outrossim, a não revelar, reproduzir, utilizar ou dar conhecimento, em hipótese alguma, a
          terceiros, bem como a não permitir que nenhum de seus funcionários e/ou prepostos faça uso desses{' '}
          <Bold>“DADOS CONFIDENCIAIS”</Bold> de forma indevida.
          <br />
          <br />
          <Bold>8.1.1.</Bold> A <Bold>BTIME</Bold> compromete-se a garantir a confidencialidade, inclusive por seus
          funcionários que, em razão de suas funções, tenham acesso aos <Bold>DADOS CONFIDENCIAIS</Bold> envolvidos nas
          atividades do presente Contrato, e por isso assumiram internamente compromisso de confidencialidade e foram
          instruídos sobre a importância de seu papel na Segurança da Informação e na Proteção de Dados Pessoais.
          <br />
          <br />
          <Bold>8.2.</Bold> As partes poderão divulgar <Bold>DADOS CONFIDENCIAIS</Bold> conforme ordem judicial, desde
          que a parte que for realizar a divulgação notifique a outra parte, no mínimo 72 (setenta e duas) horas antes à
          referida divulgação, para que esta, querendo, promova as medidas necessárias e cabíveis para a proteção dos
          seus interesses.
          <br />
          <br />
          <Bold>8.3.</Bold> As partes darão ciência imediata uma à outra sobre qualquer uso ou divulgação não autorizada
          dos <Bold>DADOS CONFIDENCIAIS</Bold>, ou de qualquer outra violação do presente Instrumento por si, ou por
          seus prepostos, e colaborarão mutuamente, de todas as formas possíveis, para recuperar a posse dos{' '}
          <Bold>DADOS CONFIDENCIAIS</Bold> e a impedir que seu uso não autorizado prossiga ou se amplie.
          <br />
          <br />
          <Bold>8.4.</Bold> As partes não divulgarão quaisquer <Bold>DADOS CONFIDENCIAIS</Bold> a terceiros durante a
          vigência deste contrato, e por um período de 03 (três) anos após o encerramento ou eventual rescisão do
          presente instrumento, com ou sem justa causa, sem prejuízo do dever legal de confidencialidade em relação aos
          <Bold>DADOS CONFIDENCIAIS</Bold> que sejam consideradas segredo comercial sob a lei aplicável, que devem
          permanecer em vigor por prazo indeterminado até que tais Informações Confidenciais deixem de exibir tal
          qualidade..
          <br />
          <br />
          <Text size="medium" bold>
            DA PROTEÇÃO DE DADOS PESSOAIS
          </Text>
          <br />
          <Bold>9.1.</Bold> As <Bold>PARTES</Bold> declaram cumprir em suas atividades com a legislação de proteção de
          dados pessoais, inclusive, mas não limitada à Constituição Federal de 1988, o Código Civil de 2002, o Código
          de Defesa do Consumidor, a Consolidação das Leis do Trabalho, o Marco Civil da Internet e seu Decreto
          Regulamentador, a Lei Geral de Proteção de Dados Pessoais (“LGPD”).
          <br />
          <br />
          <Bold>9.1.1.</Bold> Para os fins de interpretação deste Contrato e de eventuais Aditivos, serão aplicadas as
          disposições da LGPD, inclusive suas definições.
          <br />
          <br />
          <Bold>9.2.</Bold> Nas atividades de Tratamento de Dados Pessoais envolvidas no objeto deste Contrato, a{' '}
          <Bold>BTIME</Bold> atuará como Operador de Dados Pessoais, em nome e nos limites determinados pela
          CONTRATANTE, Controladora de Dados Pessoais, nos termos das cláusulas 3.1.1 e 5.1.
          <br />
          <br />
          <Bold>9.3.</Bold> A <Bold>CONTRATANTE</Bold>, enquanto Controladora de Dados Pessoais, é a única responsável
          pela definição dos meios e das finalidades do Tratamento de Dados Pessoais, não sendo responsabilidade da{' '}
          <Bold>BTIME</Bold> controlar, fiscalizar e/ou averiguar o embasamento jurídico do tratamento de dados
          realizado pela <Bold>CONTRATANTE</Bold>.
          <br />
          <br />
          <Bold>9.3.1.</Bold> A <Bold>CONTRATANTE</Bold> garante à <Bold>BTIME</Bold> que atende aos requisitos de
          transparência e informação trazidos pela LGPD, bem como que as atividades de tratamento de dados na utilização
          do SOFTWARE atendem a pelo menos uma das bases legais previstas nos artigos 7º e/ou 11 da referida Lei.
          <br />
          <br />
          <Bold>9.3.2.</Bold> Se a <Bold>CONTRATANTE</Bold> utilizar a base legal do consentimento em atividades
          desenvolvidas no <Bold>SOFTWARE</Bold> da <Bold>BTIME</Bold>, a <Bold>CONTRATANTE</Bold> será a responsável
          pela coleta e gestão do consentimento.
          <br />
          <br />
          <Bold>9.4.</Bold> Caso a <Bold>BTIME</Bold> venha a ser demandada, judicialmente ou extrajudicialmente, em
          razão de Tratamento irregular de Dados conduzido pela <Bold>CONTRATANTE</Bold>, esta última será obrigada a
          ressarcir todas e quaisquer despesas, custos (processuais ou administrativos), multas, indenizações,
          honorários advocatícios, periciais e/ou contábeis (a esses não se limitando) que a <Bold>BTIME</Bold> for
          obrigada a despender.
          <br />
          <br />
          <Bold>9.5.</Bold> A <Bold>BTIME</Bold> garante que adota na realização das atividades objeto deste Contrato as
          medidas de segurança, técnicas e administrativas aptas a proteger os dados pessoais de acessos não autorizados
          e de situações acidentais ou ilícitas de destruição, perda, alteração, comunicação ou qualquer forma de
          tratamento inadequado ou ilícito, de acordo com os Termos de Uso e Política de Privacidade do{' '}
          <Bold>SOFTWARE</Bold>.
          <br />
          <br />
          <Bold>9.6.</Bold> A <Bold>BTIME</Bold> exigirá a manutenção do nível de segurança e proteção de dados pessoais
          nas atividades realizadas por terceiros para a execução do presente Contrato. O Tratamento de Dados praticado
          por tais terceiros será realizado de acordo com suas políticas e procedimentos em proteção de dados, sob os
          quais a <Bold>BTIME</Bold> não possui qualquer ingerência ou responsabilidade.
          <br />
          <br />
          <Bold>9.7.</Bold> Em nenhuma hipótese a <Bold>BTIME</Bold> poderá ser responsabilizada pelo Tratamento dado
          pela <Bold>CONTRATANTE</Bold> em relação aos Dados Pessoais tratados pela <Bold>BTIME</Bold> ou seus
          subcontratados, em decorrência das instruções fornecidas pela <Bold>CONTRATANTE</Bold> ou das atividades
          desenvolvidas pela <Bold>CONTRATANTE</Bold> no <Bold>SOFTWARE</Bold> da <Bold>BTIME</Bold>.
          <br />
          <br />
          <Bold>9.8.</Bold> Em caso de eventual solicitação, por parte dos Titulares de Dados, de quaisquer dos direitos
          previstos no art. 18 ou 20 da LGPD, a <Bold>BTIME</Bold> cooperará com as informações existentes no{' '}
          <Bold>SOFTWARE</Bold> com a <Bold>CONTRATANTE</Bold>, responsável por atender os pedidos dos Titulares ou, em
          caso de decisão pelo não atendimento da solicitação, por responder e interagir diretamente com o Titular dos
          Dados.
          <br />
          <br />
          <Bold>9.9.</Bold> Encerrada a relação jurídica decorrente deste contrato, a <Bold>BTIME</Bold> armazenará os
          dados inseridos pela <Bold>CONTRATANTE</Bold> no <Bold>SOFTWARE</Bold>, inclusive os Dados Pessoais, pelo
          prazo de 03 (três) meses para Pequenas e Médias Empresas (<Bold>SMB</Bold>) e 06 (seis) meses para Grandes
          Empresas (<Bold>“Enterprise”</Bold>).
          <br />
          <br />
          <Bold>9.10.</Bold> Caso a <Bold>CONTRATANTE</Bold> não realize o download dos dados antes de encerrada a
          relação jurídica, poderá, dentro do referido prazo de 03 (três) meses para “Pequenas e Médias Empresas (
          <Bold>SMB</Bold>) e 06 (seis) meses para Grandes Empresas (<Bold>Enterprise</Bold>), solicitar o envio dos
          dados para a <Bold>BTIME</Bold>. Após o prazo de 03 (meses) para Pequenas e Médias Empresas (<Bold>SMB</Bold>)
          e 06 (seis) meses para Grandes Empresas (<Bold>Enterprise</Bold>) os dados serão deletados.
          <br />
          <br />
          <Text size="medium" bold>
            DA VIGÊNCIA E RESCISÃO
          </Text>
          <br />
          <Bold>10.1.</Bold> O presente contrato terá vigência pelo prazo de 12 (doze) meses, a contar da data de
          assinatura, renovando-se automaticamente por iguais períodos, salvo manifestação contrária de qualquer das
          partes, mediante notificação por escrito com antecedência mínima de 30 (trinta) dias do término da vigência.
          <br />
          <br />
          <Bold>10.2.</Bold> Caso qualquer das partes deseje rescindir este contrato de forma imotivada antes do término
          do prazo de vigência, deverá comunicar sua decisão por escrito, via e-mail com confirmação de recebimento.
          <br />
          <br />
          <Bold>10.3.</Bold> No caso de rescisão imotivada unilateral por parte da <Bold>CONTRATANTE</Bold>, será devida
          à <Bold>CONTRATADA</Bold> multa compensatória no valor correspondente a 30% (trinta por cento) do saldo
          remanescente do contrato até o final do período de 12 (doze) meses, salvo negociação diversa entre as partes.
          <br />
          <br />
          <Bold>10.4.</Bold> Este contrato será considerado automaticamente rescindido, independentemente de qualquer
          formalidade adicional e sem ônus, no caso de falência, liquidação ou recuperação judicial ou extrajudicial de
          qualquer das partes.
          <br />
          <br />
          <Bold>10.5.</Bold> Em qualquer hipótese de término ou rescisão do presente contrato, a{' '}
          <Bold>CONTRATANTE</Bold> permanecerá responsável pelo pagamento dos valores devidos à <Bold>CONTRATADA</Bold>{' '}
          pelos serviços efetivamente prestados até a data da rescisão, além da multa prevista nesta cláusula, se
          aplicável.
          <br />
          <br />
          <Text size="medium" bold>
            DAS DISPOSIÇÕES GERAIS
          </Text>
          <br />
          <Bold>11.1. </Bold> É vedado às partes ceder ou transferir a terceiros os direitos e obrigações decorrentes do
          presente instrumento, total ou parcialmente, salvo se com a concordância prévia e expressa da outra parte.
          <br />
          <br />
          <Bold>11.2. </Bold> Este contrato obriga as partes e seus sucessores, a qualquer título, e não cria entre as
          partes nenhum tipo de vínculo empregatício, sociedade, associação, consórcio, ou qualquer outro tipo de
          relação que não a contratação autônoma de prestação de serviços.
          <br />
          <br />
          <Bold>11.3. </Bold> No caso de quaisquer conflitos entre os termos deste contrato e da proposta comercial,
          este contrato prevalecerá.
          <br />
          <br />
          <Bold>11.4. </Bold>A tolerância de uma parte para com a outra, relativamente a descumprimento de qualquer das
          obrigações ora assumidas, não será considerada novação ou renúncia a qualquer direito, constituindo mera
          liberalidade, que não impedirá a parte tolerante de exigir da outra o fiel cumprimento deste contrato, a
          qualquer tempo.
          <br />
          <br />
          <Bold>11.5. </Bold> As partes elegem o Foro da Comarca de São Paulo, com renúncia expressa a qualquer outro,
          por mais privilegiado que seja ou venha a ser, para dirimir qualquer dúvida ou controvérsia decorrente da
          interpretação ou execução do presente contrato, que será regido e interpretado de acordo com as Leis vigentes
          na República Federativa do Brasil.
          <br />
          <br />
          <Bold>11.6. </Bold> As Partes concordam que o presente Contrato, pode ser assinado digitalmente, nos termos da
          Lei n.º 13.874/2019, bem como na Lei n.º 14.063/2020, Medida Provisória 2.200-2/2001, no Decreto 10.278, e
          ainda, no Enunciado n.º 297 do Conselho Nacional de Justiça.
          <br />
          <br />E por estarem acordadas, as partes assinam o presente instrumento em 2 (duas) vias de igual teor e
          forma, juntamente com duas testemunhas, para os devidos fins e efeitos de direito.
        </View>
      </Text>
    </>
  )
}

const ContentProposta = () => {
  const serviceOrder = useParentServiceOrder()

  if (serviceOrder?.checklist?.id === 188) return <PropostaSmb repliesParent={serviceOrder?.replies} />
  if (serviceOrder?.checklist?.id === 191) return <PropostaEnterprise repliesParent={serviceOrder?.replies} />

  return <></>
}

const Header = () => (
  <>
    <Grid justify="left" align="left">
      <Image src="/btime-logo-roxo.png" maxWidth={150} ignoreFixedSize />
    </Grid>
    <Separator weight={10} />
  </>
)

const TemplateContratoPdfPage = ({ id, templateId }) => {
  return (
    <AbsolutePageTemplate>
      <ServiceOrderLoader>
        <ParentServiceOrderLoader>
          <PdfOptionsFormHandler initialState={{ fontBaseColor: COLORS.dark1 }}>
            <PageHeader templateId={parseInt(templateId)} />
            <Grid align="stretch">
              <Col flex={3} flex_mdd={0} hideOn="mdd" scroll height="calc(100vh - 4.3rem)">
                <Preview>
                  <Page>
                    <Content />
                  </Page>
                </Preview>
              </Col>
            </Grid>
          </PdfOptionsFormHandler>
        </ParentServiceOrderLoader>
      </ServiceOrderLoader>
    </AbsolutePageTemplate>
  )
}

export default TemplateContratoPdfPage
